<template>
  <button class="icon-button" @click="toggle">
    <div class="tooltipContainer">
      <div class="toolbarIconContainer">
        <div class="icon-settings chat-icon" :style="transparentColor">
          <IconBase
            iconColor="#111"
            viewBox="0 0 512 512"
            width="100%"
            height="100%"
            ><IconChat />
          </IconBase>
          <div v-if="chatIndicator" class="chat-indicator"></div>
        </div>
      </div>
      <div class="tooltipElement chatTooltip">
        <span class="tooltipTip">Chat</span>
        <span class="tooltipShortcut">ALT+X</span>
      </div>
    </div>
  </button>
</template>

<script>
import { mapState } from "vuex";
import IconBase from "../../../../../components/IconBase";
import IconChat from "../../../../../components/SVG/IconChat";

import { transparentColor } from "../../SessionHelpers/colors";

export default {
  name: "ChatToggle",
  components: {
    IconBase,
    IconChat,
  },
  computed: {
    ...mapState({
      chat: (state) => state.toolbar.toolbarConfig.chat,
      chatIndicator: (state) => state.toolbar.toolbarConfig.chatIndicator,
    }),
    transparentColor() {
      return transparentColor();
    },
  },
  methods: {
    toggle() {
      if (!this.chat) {
        this.$store.dispatch("toolbar/toggleChatIndicator", false);
      }
      this.$store.dispatch("toolbar/toggleToolbar", "chat");
    },
  },
};
</script>

<style scoped>
@import "../../SessionStyles/Icon.css";
@import "../../SessionStyles/Tooltip.css";

.chatTooltip {
  top: 52px;
  bottom: 0;
  margin-left: 34px;
  margin-right: 34px;
}

.chat-icon {
  width: 22px;
  height: 22px;
  padding: 11px;
}

.chat-indicator {
  width: 14px;
  height: 14px;
  position: absolute;
  border-radius: 360px;
  right: -1px;
  top: -3px;
  cursor: pointer;
  background-image: linear-gradient(#5aa6ff, #06f);
  background-clip: padding-box;
}
</style>